<script>
  export let about;
  import blocksToHtml from "@sanity/block-content-to-html";
</script>

<section id="about">
  <h1>Esther Muñoz Ramos</h1>
  {@html blocksToHtml({ blocks: about })}
</section>
